import { ConfigurationAutomaticOntologyValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'

export interface ValuableConceptsModalBasicRelationshipsState {
    valuableConcepts: ConfigurationAutomaticOntologyValuableConceptResponse[]
}
export const initialValuableConceptsModalBasicRelationshipsState =
    (): ValuableConceptsModalBasicRelationshipsState => ({
        valuableConcepts: []
    })
